'use client';

import { useEffect } from 'react';

export default function ScrollAnimations() {
  useEffect(() => {
    // Native CSS scroll-based reveal using IntersectionObserver
    const revealEls = document.querySelectorAll('.section-reveal');

    // Set initial hidden state
    revealEls.forEach((el) => {
      (el as HTMLElement).style.opacity = '0';
      (el as HTMLElement).style.transform = 'translateY(36px)';
      (el as HTMLElement).style.transition = 'opacity 0.8s cubic-bezier(0.23, 1, 0.32, 1), transform 0.8s cubic-bezier(0.23, 1, 0.32, 1)';
    });

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const el = entry.target as HTMLElement;
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );

    revealEls.forEach((el) => observer.observe(el));

    // Hero staggered reveal
    const heroEls = document.querySelectorAll('.hero-reveal');
    heroEls.forEach((el, i) => {
      const htmlEl = el as HTMLElement;
      htmlEl.style.opacity = '0';
      htmlEl.style.transform = 'translateY(32px)';
      htmlEl.style.transition = `opacity 1s cubic-bezier(0.23, 1, 0.32, 1) ${i * 150}ms, transform 1s cubic-bezier(0.23, 1, 0.32, 1) ${i * 150}ms`;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          htmlEl.style.opacity = '1';
          htmlEl.style.transform = 'translateY(0)';
        });
      });
    });

    // Navbar scroll effect
    const navbar = document.querySelector('header') as HTMLElement | null;
    const handleScroll = () => {
      if (!navbar) return;
      if (window.scrollY > 60) {
        navbar.classList.add('nav-scrolled');
      } else {
        navbar.classList.remove('nav-scrolled');
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return null;
}